import PropTypes from 'prop-types';
import React from 'react';
import classNames from 'classnames';
import { Icon } from '../KeyComponents';

function InlineDropdownItem(props) {
  const {
    icon,
    iconType,
    label,
    onClick,
    className,
    flag,
    disabled,
  } = props;

  const handleKeyPress = (event) => {
    if (event.key === 'Enter' && !disabled) {
      onClick();
    }
  };

  return (
    <div
      className={classNames('inlinedropdown-item', className, { 'inlinedropdown-item-disabled': disabled })}
      onClick={!disabled ? onClick : undefined}
      onKeyPress={handleKeyPress}
      role="button"
      tabIndex={0}
      key={label}
    >
      {flag && <i className={`round-flag-icon round-flag-${flag} flag-icon`}></i>}
      {icon && <Icon className="inlinedropdown-item-icon" icon={icon} type={iconType} alt={icon} />}
      <span className="inlinedropdown-item-label">{label}</span>
    </div>
  );
}

InlineDropdownItem.propTypes = {
  icon: PropTypes.node,
  label: PropTypes.string,
  className: PropTypes.string,
  onClick: PropTypes.func,
  iconType: PropTypes.string,
  disabled: PropTypes.bool,
  flag: PropTypes.string,
};

InlineDropdownItem.defaultProps = {
  onClick: () => { },
  icon: null,
  label: '',
  className: '',
  iconType: 'line',
  disabled: false,
  flag: '',
};

export default InlineDropdownItem;
